import React from 'react';
import { Shield, Sparkles, Award, Truck, RefreshCw, Star } from 'lucide-react';

const trustItems = [
  { icon: Shield, text: '100% Natural & Authentic' },
  { icon: Sparkles, text: 'Energised by Top Astrologers' },
  { icon: Award, text: 'Lab Certified Products' },
  { icon: Truck, text: 'Fast Pan-India Delivery' },
  { icon: RefreshCw, text: '7 Day Easy Returns' },
  { icon: Star, text: '50,000+ Happy Customers' },
];

export const TrustMarquee = () => {
  return (
    <div className="bg-gradient-to-r from-amber-600 via-orange-500 to-amber-600 py-2.5 overflow-hidden" data-testid="trust-marquee">
      <div className="flex animate-marquee whitespace-nowrap">
        {[...trustItems, ...trustItems, ...trustItems].map((item, idx) => (
          <div 
            key={idx} 
            className="flex items-center gap-2 mx-8 text-white"
          >
            <item.icon className="w-4 h-4 flex-shrink-0" />
            <span className="text-sm font-medium">{item.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
